import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input, signal } from '@angular/core';
import { SystemBanner } from '../../shared/models/system-banner/system-banner.model';

@Component({
	selector: 'app-system-banner',
	templateUrl: './system-banner.component.html',
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SystemBannerComponent {
	systemBannerMessages = input<SystemBanner[]>([]);
	title = 'Title';
	private readonly dismissed = signal<Map<string, { message?: string; title?: string }>>(new Map());
	readonly visibleMessages = computed(() =>
		this.systemBannerMessages().filter(m => {
			const dismissedMessage = this.dismissed().get(m.SystemBannerId);
			return dismissedMessage === undefined || dismissedMessage?.message !== m?.Message || dismissedMessage?.title !== m?.Title;
		})
	);

	dismiss(message: SystemBanner): void {
		this.dismissed.update(map => new Map([...map, [message.SystemBannerId, { message: message?.Message, title: message?.Title }]]));
	}

	getBannerClasses(message: SystemBanner): string {
		const severity = message?.BannerType ?? 1;
		switch (severity) {
			case 0:
				return 'system-banner-info';
			case 1:
			default:
				return 'system-banner-warning';
		}
	}
}
